import React, { useMemo, useState } from "react"
import { Button, CardHeader, CardBody } from "reactstrap"
import { AnalyseExecutionResponse } from "../types"
import WordCloudSlide from './WordCloudSlide'

const WordCloudSection: React.FC<{
  analyseResponse?: AnalyseExecutionResponse;
  handleKeyPhrase: (p: string) => void;
}> = ({ analyseResponse: executionInfo, handleKeyPhrase }) => {
  const [activeSlideIdx, setActiveSlideIdx] = useState(0)

  const wcSlides = useMemo(() => {
    const words: { ngram: number, words: Record<string, number> }[] = []
    if (executionInfo?.wc2Words) {
      words.push({
        words: executionInfo.wc2Words,
        ngram: 2
      })
    }
    if (executionInfo?.wc3Words) {
      words.push({
        words: executionInfo.wc3Words,
        ngram: 3,
      })
    }
    // if (executionInfo?.wc1Words) {
    //   words.push({
    //     words: executionInfo.wc1Words,
    //     ngram: 1
    //   })
    // }
    return words
  }, [executionInfo])

  return (
    <>
      <CardHeader>
      <div>
        <h2 style={{ display: 'inline' }}>
          Word Clouds
        </h2>
        <span className="float-right">
          <Button color="primary" size="sm" onClick={() => {
            if (activeSlideIdx === 0) return
            setActiveSlideIdx(activeSlideIdx - 1)
          }}>
            Prev
          </Button>
          <Button className="ml-2" color="primary" size="sm" onClick={() => {
            if (activeSlideIdx === wcSlides.length - 1) return
            setActiveSlideIdx(activeSlideIdx + 1)
          }}>
            Next
          </Button>
        </span>
      </div>
      </CardHeader>
      <CardBody style={{
                backgroundColor: "#fff",
                borderRadius: "5px"
              }}>
      <div >
        {
          wcSlides.map((sl, i) => (
            <WordCloudSlide
              key={i}
              idx={i}
              activeSlideIdx={activeSlideIdx}
              words={sl.words}
              ngram={sl.ngram}
              setPhrase={handleKeyPhrase}
            />
          ))
        }
      </div>
      </CardBody>
    </>
  )
}

export default WordCloudSection
